import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from "@angular/forms";
import { ApplicationSectionBaseComponent } from '../../../../../applications/components/application-section-base/application-section-base.component';
import { ApplicationSteps, ApplicationState } from "../../../../../applications/models/applications.models";
import { AuthService } from "../../../../../services/auth.service";
import { Option } from "../../../../../common/models/flow.dto";

@Component({
    selector: 'unitization',
    templateUrl: './unitization.component.html',
    styleUrls: ['./unitization.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class UnitizationComponent extends ApplicationSectionBaseComponent implements OnInit {

    readonly step: ApplicationSteps = ApplicationSteps.Unitization;

    @Input() form: FormGroup;

    yesNo: Option[] = [
        { id: "No", text: "No" } as Option,
        { id: "Yes", text: "Yes" } as Option
    ];

    constructor(auth: AuthService) {
        super(auth);

    }

    ngOnInit() {
        let subjectCtrl = this.form.get('subjectToOrder');
        if (subjectCtrl != null) this.orderSubjectChanged(subjectCtrl.value);
    }

    orderSubjectChanged(value: string): void {
        let orderCtrl = this.form.get('orderNumber');
        if (orderCtrl != null) {
            if (value == "No" || value == null) {
                orderCtrl.setValue(null);
                orderCtrl.disable();
            } else if (this.reviewStates.includes(this.applicationState) == false && (this.applicationState == ApplicationState.Start || this.applicationState == ApplicationState.Input || this.fieldHasNotes("unitization|orderNumber"))) {
                orderCtrl.enable();
            }
        }

    }

    toggleOpen(): void {
        if (this.step == this.activeStep || !this.isOpen) super.toggleOpen();
        this.openChanged.emit(this.step);
    }

}
